var _g, _path, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardso401(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_13506_34432)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 5,
    width: 40,
    height: 40,
    rx: 5,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.5,
    y: 5.5,
    width: 39,
    height: 39,
    rx: 4.5,
    stroke: "#06513D",
    shapeRendering: "crispEdges"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_13506_34432",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 10,
    width: 30,
    height: 27
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 10H41.1425V37H12V10Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_13506_34432)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.3629 17.2789C19.2421 17.4892 18.9734 17.5613 18.7649 17.4405C18.5546 17.3198 18.4825 17.0529 18.6033 16.8426L20.5783 13.4203C21.821 11.2661 23.9733 10.0234 26.4586 10.0234C28.087 10.0234 29.5692 10.5571 30.7476 11.5271C30.7515 11.531 30.7554 11.533 30.7613 11.5349C32.3779 12.2127 33.2057 14.1878 32.3273 15.8765C32.3175 15.896 32.2961 15.9096 32.2727 15.9077C30.1399 15.8142 28.7667 13.6775 29.4485 11.7433C29.4582 11.7161 29.4485 11.6868 29.4231 11.6732C28.5525 11.1707 27.5474 10.9038 26.4586 10.9038C24.281 10.9038 22.4267 11.9732 21.3379 13.8605H21.336L19.3629 17.2789ZM26.7975 26.1899H30.6152C30.6483 26.1899 30.6756 26.1627 30.6756 26.1296V22.7521C30.6756 22.4814 30.4535 22.2593 30.1828 22.2593H26.7975C26.7664 22.2593 26.7391 22.2866 26.7391 22.3197V26.1315C26.7391 26.1627 26.7664 26.1899 26.7975 26.1899ZM21.9827 26.1899H25.8003C25.8334 26.1899 25.8587 26.1627 25.8587 26.1296V22.3197C25.8587 22.2866 25.8334 22.2593 25.8003 22.2593H22.4151C22.1463 22.2593 21.9242 22.4814 21.9242 22.7521V26.1296C21.9242 26.1627 21.9495 26.1899 21.9827 26.1899ZM28.2662 21.3205V17.9372C28.2662 17.6665 28.0461 17.4444 27.7753 17.4444H24.8245C24.5537 17.4444 24.3317 17.6665 24.3317 17.9372V21.3205C24.3317 21.3536 24.357 21.3809 24.3901 21.3809H28.2077C28.2408 21.3809 28.2662 21.3536 28.2662 21.3205ZM31.8598 35.3328C33.007 33.533 35.543 33.4123 36.8773 34.9705C36.8967 34.9919 36.9279 34.9958 36.9513 34.9822C37.8219 34.4796 38.5582 33.7414 39.1016 32.8007C40.1865 30.9211 40.1865 28.7668 39.1016 26.8872L35.3405 20.3739C35.2178 20.1635 35.2898 19.8947 35.5002 19.774C35.7105 19.6532 35.9793 19.7233 36.1001 19.9337L39.8612 26.447C41.102 28.5935 41.1117 31.0983 39.8593 33.2389H39.8612C39.0471 34.651 37.8434 35.6697 36.4137 36.2054C36.4078 36.2073 36.402 36.2093 36.3981 36.2132C35.0035 37.2727 32.8824 37.0001 31.8598 35.397C31.8462 35.3776 31.8462 35.3542 31.8598 35.3328ZM15.2434 25.2628C16.2289 27.158 15.0661 29.4135 13.0502 29.7914C13.021 29.7953 13.0015 29.8186 13.0015 29.8478C13.0015 30.8548 13.2722 31.8599 13.8157 32.8007C14.9045 34.6842 16.7587 35.7554 18.9363 35.7554H26.4586C26.7021 35.7554 26.8988 35.9522 26.8988 36.1956C26.8988 36.4391 26.7021 36.6358 26.4586 36.6358H18.9363C16.4471 36.6358 14.3045 35.3951 13.056 33.2389C12.4347 32.1657 12.1211 30.997 12.1211 29.844C12.1211 29.4856 12.1523 29.1252 12.2107 28.7688C12.2126 28.7629 12.2126 28.759 12.2126 28.7513C11.9925 27.0158 13.2898 25.3154 15.1888 25.2316C15.2122 25.2297 15.2317 25.2414 15.2434 25.2628ZM20.7614 27.0508H31.8384C32.6116 27.0508 33.2447 27.6839 33.2447 28.4571C33.2447 29.2304 32.6116 29.8634 31.8384 29.8634H30.8645C30.8411 29.8634 30.8216 29.8771 30.8119 29.8985C30.8022 29.9199 30.8061 29.9452 30.8216 29.9628C31.6202 30.8393 31.0067 32.3001 29.7796 32.3001C28.5525 32.3001 27.937 30.8393 28.7356 29.9628C28.7531 29.9452 28.757 29.9199 28.7473 29.8985C28.7375 29.8771 28.7161 29.8634 28.6927 29.8634H23.9051C23.8817 29.8634 23.8603 29.8771 23.8525 29.8985C23.8428 29.9199 23.8467 29.9433 23.8623 29.9628C24.6608 30.8393 24.0453 32.3001 22.8183 32.3001C21.5931 32.3001 20.9776 30.8393 21.7762 29.9628C21.7918 29.9452 21.7957 29.9199 21.7859 29.8985C21.7762 29.8771 21.7567 29.8634 21.7333 29.8634H20.7614C19.6239 29.8634 18.9558 28.5701 19.6142 27.6469C19.6239 27.6313 19.6278 27.6118 19.62 27.5923L17.0509 20.3057C16.9107 19.9064 16.5659 19.663 16.1432 19.663H14.5461C14.3026 19.663 14.1059 19.4662 14.1059 19.2228C14.1059 18.9793 14.3026 18.7826 14.5461 18.7826H16.1432C16.9301 18.7826 17.6177 19.2695 17.8807 20.0136L20.3621 27.0528C20.3719 27.082 20.403 27.0976 20.4322 27.0898C20.5374 27.0645 20.6465 27.0508 20.7614 27.0508Z",
    fill: "#06513D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_13506_34432",
    x: 0.8,
    y: 0.8,
    width: 52.4,
    height: 52.4,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.529412 0 0 0 0 0.639216 0 0 0 0.52 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_13506_34432"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_13506_34432",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardso401);
export default __webpack_public_path__ + "static/media/dashboardso401.1a38aea21201a0f7a5af283bd95424df.svg";
export { ForwardRef as ReactComponent };